import i18next from "i18next";
import { IGroupedData } from "./CalendarioObblighi.types";

// Funzione per ottenere l'header dell'ultima colonna dal CSV
export const getLastColumnHeader = (csvData: string[][]) => {
  if (csvData.length === 0 || csvData[0].length === 0) {
    return "PVR"; // Fallback di default
  }
  return csvData[0][csvData[0].length - 1]; // Ultima colonna della prima riga (header)
};

// Variabile per memorizzare l'header PVR corrente
let currentPvrHeader = "PVR";

// Funzione per ottenere l'header PVR corrente
export const getCurrentPvrHeader = () => currentPvrHeader;

export const HEADERS_LABEL = {
  AMBITO: "Ambito Normativo",
  CODE_SEL: "Codice Sel",
  DECADE: "Decade",
  DESTINATARI: "DESTINATARI",
  ENGLISH: "Inglese",
  ITALIAN: "Italiano",
  MONTH: "Mese di Pubblicazione",
  TITLE_SELECTION: "Titolo Selection"
} as const;


export const languagesString = (italian: string, english: string): string => {
  const languages = [
    italian.trim().toUpperCase() === "X" && "Italiano",
    english.trim().toUpperCase() === "X" && "Inglese"
  ].filter(Boolean) as string[];

  return languages.length ? languages.join(", ") : i18next.t("calendario_obblighi.no_languages");
};

export const checkPvr = (pvr: string) => pvr === "SI";

export const sortByRecipients = (csvData: string[][]): IGroupedData[] => {
  const lastColumnHeader = getLastColumnHeader(csvData);
  currentPvrHeader = lastColumnHeader;

  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

  const grouped = csvData.slice(1).reduce<Record<string, IGroupedData>>((acc, row) => {
    const recipient = row[5]?.trim();
    if (!recipient) return acc;

    const nuovoElemento = {
      "Ambito Normativo": row[1],
      "Codice Sel": row[0],
      "DESTINATARI": row[5],
      "Decade": row[7],
      "Inglese": row[3],
      "Italiano": row[2],
      "Mese di Pubblicazione": capitalize(row[6] ?? ""),
      "Titolo Selection": row[4],
      [lastColumnHeader]: row[8]
    };

    if (!acc[recipient]) {
      acc[recipient] = { data: [], label: recipient };
    }

    acc[recipient].data.push(nuovoElemento);
    return acc;
  }, {});

  return Object.keys(grouped)
    .sort((a, b) => a.localeCompare(b, "it"))
    .map(key => grouped[key]);
};

export const activeRecipientData = (groupedData: IGroupedData[], active: string) => {
  const activeRecipient = groupedData.find(item => item.label === active) ?? null;
  return activeRecipient?.data;
};
